import fromArea from './from-area-animation'
import fromBar from './from-bar-animation'
import fromLine from './from-line-animation'
import hierarchyDrilldown from './hierarchy-drilldown-animation'
import hierarchyDrillup from './hierarchy-drillup-animation'
import pieCount from './pie-count-animation'
import splitSerie from './split-serie-animation'
import unsplitSerie from './unsplit-serie-animation'
import entering from './entering-serie-animation'
import exiting from './exiting-serie-animation'
import basic from './basic-animation' // Last resort, draws a pie

// Order matters
export default [
  fromArea,
  fromBar,
  fromLine,
  hierarchyDrilldown,
  hierarchyDrillup,
  pieCount,
  splitSerie,
  unsplitSerie,
  entering,
  exiting,
  basic
]
